(() => {
  if (window.__vcSizechartBound) return;
  window.__vcSizechartBound = true;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  function setFocus(element) {
    if (!element || typeof element.focus !== 'function') return;

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function getElements(key) {
    return {
      modal: document.querySelector(`[data-vc-sizechart-modal="${key}"]`),
      overlay: document.querySelector(`[data-vc-sizechart-overlay="${key}"]`),
      trigger: document.querySelector(`[data-vc-sizechart-open="${key}"]`),
    };
  }

  function syncPageScroll() {
    document.body.classList.toggle(
      'vc-sizechart-open',
      document.querySelector('.vc-sizechart-modal.is-open[data-vc-sizechart-modal]') !== null
    );
  }

  function toggleSizechart(key, shouldOpen) {
    const { modal, overlay, trigger } = getElements(key);
    if (!modal || !overlay) return;

    modal.classList.toggle('is-open', shouldOpen);
    overlay.classList.toggle('is-open', shouldOpen);
    modal.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    overlay.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    trigger?.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    syncPageScroll();

    if (shouldOpen) {
      setFocus(modal.querySelector('[data-vc-sizechart-close]') || modal);
    } else {
      setFocus(trigger);
    }
  }

  function closeOpenSizecharts() {
    document.querySelectorAll('.vc-sizechart-modal.is-open[data-vc-sizechart-modal]').forEach((modal) => {
      toggleSizechart(modal.dataset.vcSizechartModal, false);
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-vc-sizechart-open]');
    if (openButton) {
      event.preventDefault();
      toggleSizechart(openButton.dataset.vcSizechartOpen, true);
      return;
    }

    const closeButton = event.target.closest('[data-vc-sizechart-close]');
    if (closeButton) {
      event.preventDefault();
      toggleSizechart(closeButton.dataset.vcSizechartClose, false);
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('.vc-sizechart-modal.is-open[data-vc-sizechart-modal]');
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeOpenSizecharts();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(modal.querySelectorAll(focusableSelector));
    if (!focusableElements.length) {
      event.preventDefault();
      setFocus(modal);
      return;
    }

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      setFocus(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      setFocus(first);
    }
  });
})();
